import { Injectable, InjectionToken } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { REGISTRY } from '../interfaces/registry-services';
import { HTTPService } from './http.service';
import { SnackbarService } from './snackbar.service';
import { ObjectUtil } from '../system-utils/utils/ObjectUtil';

@Injectable()
export class RefreshPreferencesServices {
    
    constructor(private http:HTTPService, private snackBar:SnackbarService){

    }
    sub:Subscription;
    
   getPreferences (name){ 
    return new Promise((resolve, reject) => {
      let local = {
        entityName: "Mktppref",
        showImageData: false,
        showImagaDataBase64: false,
        showPresentation: false,
        showRelationshipData: false,
        showRelationship: false,
        condition: `name='${name}'`,
      };

      this.http
        .post(local, "JsonBrokerServices/find", false, true, true)
        .subscribe(
          (result) => {
            
            if (ObjectUtil.isNotEmpty(result["Mktppref"])) {
              if (ObjectUtil.isNotEmpty(result["Mktppref"])) {
                if ((result["Mktppref"] as Object[]).length > 0) {
                  let components:any = result["Mktppref"][0]["TEXT"];
                  resolve(components);
                }
              }
            }
            resolve([]);
          },
          (error) => {
            throw error;
          }
        );
    });
  }

    refresh(data){
        
        this.sub = this.http.post({},"PreferenceServices/reloadPreference",true,true,false).subscribe(x=>{
            this.snackBar.showSuccess("Preferências carregadas BackEnd com sucesso .");
        },
        (error)=>{
            throw error;
        });

        

    }

    clearCache(data){
        
        this.sub = this.http.post({},"SystemServices/clearCache",true,true,false).subscribe(x=>{
            this.snackBar.showSuccess("Cache Dicionario de Dados descartado BackEnd com sucesso.");
    
        },
        (error)=>{
            throw error;
        });


    }

    ngOnDestroy(){
        if (this.sub!= null ) {this.sub.unsubscribe();}
      }

}